import { Modal } from "@mui/material";
import classNames from "classnames";

import { IDialogModalProps } from "../models";
import styles from "./styles.module.scss";

import { ReactComponent as Close } from "../../../assets/images/svg/closeDark.svg";

interface Props extends IDialogModalProps {
  className?: string;
}

export const DialogModal = ({
  open,
  handleClose,
  children,
  title,
  className = "",
}: Props): JSX.Element => {
  return (
    <Modal open={open} onClose={handleClose} className={styles.modalContainer}>
      <div
        className={classNames(
          styles["card"],
          styles["modal_body"],
          className && className
        )}>
        <div className={styles.header}>
          <div onClick={handleClose} className={styles.close_icon}>
            <Close />
          </div>
          <h1>{title}</h1>
        </div>
        {children}
      </div>
    </Modal>
  );
};
